import React from 'react';

export default function CrownIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 17L4 7L8 11L12 4L16 11L20 7L22 17H2Z"
        fill={color}
      />
      <rect x="2" y="17" width="20" height="3" rx="1" fill={color} />
    </svg>
  );
}
